import { InitialState } from "./types";

export const initialState: InitialState = {
  formData: {
    initialDetails: {
      kindOfDegradedLand: "82092737-0b4b-4d2a-9adf-64721654b10c",
      stateName: "",
      districtName: "",
      areaSize: null,
      khasraNumber: "",
      division: "",
      range: "",
      grossareaSize: null,
      beta: "",
      compartment: "",
      treeCanopyDensity: null,
      coordinates: {
        lat: "",
        long: "",
      },
      siteName: "",
      revenueBlock: "",
      legalStatusOfLand: "",
      topography: "",
      accessibility: "",
      climaticZone: "",
      availableInspectionPaths: "",
      landUseCategory: "",
      circleName: "",
      slope: "", // added
      terrain: "",
      legalStatusOfLandOther: "",
    },

    baselineData: {
      edaphicDetails: "",
      slopeAndTerrain: "",
      geologicalFeatures: "",
      hydrologicalConditions: "",
      forestType: "",
      anyExistingRestrictions: "",
      communityDependency: "",
      rightsAndUsage: "",
      proximityToLocalCommunities: "",
      existingFauna: "",
      presenceOfInvasiveSpecies: "",
      dominantSpecies: "",
      typeOfVegetation: "",
      distanceToNearestWaterSource: "",
      waterSupplyLines: "",
      sourceOfWater: "",
      soilpH: "",
      soilMoistureRegime: "",
      soilDepthAndTexture: "",
      soilType: "",
      soilCharacteristics: "",
      averagRainfall: "",
      seedlingDetails: [
        { commonName: "", botanicalName: "", numberOfSeedlings: "" },
      ],
      invasiveSpeciesDetails: "",
    },

    uploadedIds: {
      gpsBoundaries: {
        id: "",
        url: "",
      },
      gpsBoundariesCsv: {
        id: "",
        url: "",
      },
      droneCameraVideo: {
        id: "",
        url: "",
      },
    },

    uploadedImages: [],

    otherDetails: {
      totalNoOfGrids: null,
      landFreeFromEncumbrances: false,
      landSuitableForPlantation: false,
      landSuitableForDensity: false,
    },
  },
  isError: {
    isError: false,
    msg: "",
  },
  stepName: "ProjectDetails",
  stepDetail: {
    stepName: "ProjectDetails",
    totalStep: 4,
    currentStep: 1,
  },
  showModal: false,
  projectType: "TREE_PLANTATION",
};
